
import { defineComponent, ref } from 'vue'
export default defineComponent({
    name: "button-add-files",
    props: {
    id: {
      type:Number,
      required: true
    },
    state: {
      type:String,
      required: true
    }
    },
    emits: ["uploadFile"],
    setup(props, { emit }) {
    const file = ref(null);
    const handleFileUpload = async (event:any, id:number) => {
      file.value = event.target.files[0];
      emit("uploadFile", { file: event.target.files[0], id });   
    };
    const cargarDocumento = (e:any) => {
      document.getElementById(e)?.click();
    };
        return {
      cargarDocumento,
      handleFileUpload,
    };
    },
})
